import { render, staticRenderFns } from "./UploadEmMassa.vue?vue&type=template&id=ca933f84"
import script from "./UploadEmMassa.vue?vue&type=script&lang=js"
export * from "./UploadEmMassa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports